import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import Pcc from '../../../module/cert/Pcc/PccV4'
import PccMobile from '../../../module/cert/Pcc/PccV4Mobile'
import { alertActions, loaderActions, regisActions, certificateActions } from '../../../store/actions'
import history from '../../../route/history'
import * as common from '../../../assets/js/common.js'

export const RegisUserStep1 = (props) => {
  const [state, setState] = useState(props.location.state)
  // 본인인증 popup open 여부
  const [isPccOpen, setIsPccOpen] = useState(false)
  const [certResult, setCertResult] = useState(false)

  const enterMemberInfo = () => {
    setIsPccOpen(false)
  }

  useEffect(() => {
    // 본인인증 정보 초기화
    props.setInitialState()
  }, [])

  useEffect(() => {
    if (certResult) {
      let agreeInfo = state?.agreeInfo
      let userInfo = state?.userInfo
      let invtId = userInfo?.invtId

      // 휴대폰번호, 인증CI값 중복체크 userSeCd: 01(개인회원)
      if (props.cellNo && props.certCi) {
        props.checkMobile(invtId ? '03' : '01', props.cellNo, props.certCi)
      }

      history.replace({ pathname: '/regis/RegisUserStep2', state: { agreeInfo, userInfo } })
    }
  }, [certResult])

  return (
    <div id="contents">
      <div className="content-header type2">
        {/* mobile 뒤로가기 버튼 */}
        <a
          onClick={(e) => {
            e.preventDefault()
            window.history.back()
          }}
          className="page-prev"
        >
          뒤로이동
        </a>
        <h2>회원가입</h2>
        <div className="breadcrumb">
          <span>Home</span>
          <em>회원가입</em>
        </div>
      </div>
      <div className="join-wrap">
        <ul className="steps">
          <li>
            <span className="num">1</span>약관동의
          </li>
          <li className="on">
            <span className="num">2</span>본인인증
          </li>
          <li>
            <span className="num">3</span>회원정보 입력
          </li>
          <li>
            <span className="num">4</span>가입완료
          </li>
        </ul>
        <div className="certify">
          <dl>
            <dt>본인 인증</dt>
            <dd>
              전자문서지갑 회원으로 가입하기 위해서는
              <br /> 반드시 <strong>휴대폰 인증</strong>을 해야 합니다.
            </dd>
          </dl>
          <button type="button" className="btn-primary lg" onClick={() => setIsPccOpen(true)}>
            휴대폰 인증
            {common.getDeviceType() !== 'MobileApp' ? (
              <Pcc isPccOpen={isPccOpen} onChange={enterMemberInfo} callBack={setCertResult} />
            ) : (
              <PccMobile isPccOpen={isPccOpen} onChange={enterMemberInfo} callBack={setCertResult} />
            )}
          </button>
        </div>
        <div className="guide-box gray mt70">
          <dl className="dlist1">
            <dt>이용안내</dt>
            <dd>전자지갑 서비스를 이용하기 위해서는 휴대폰 인증을 하시기 바랍니다.</dd>
            <dd>휴대폰 인증은 본인 명의의 휴대폰 번호로 인증이 가능합니다.</dd>
            <dd>휴대폰 인증은 인증기관을 통해 실명인증을 받게 되며, 입력하신 주민등록번호는 저장되지 않습니다.</dd>
          </dl>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  certResult: state?.certificate?.resultInfo?.result,
  cellNo: state?.certificate?.resultInfo?.cellNo,
  certCi: state?.certificate?.resultInfo?.ci1,
})

const mapDispatchToProps = {
  loading: loaderActions.loading,
  info: alertActions.info,
  error: alertActions.error,
  success: alertActions.success,
  checkMobile: regisActions.checkMobile,
  setInitialState: certificateActions.setInitialState,
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisUserStep1)
